import  { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';
import styles from "./summercamp.module.css"
import 'react-toastify/dist/ReactToastify.css';
import { ArrowBackIosNewRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { hasStoredTabAccess } from '../utils/access';

const SummerCamp = () => {
    const [open, setOpen] = useState(false);
    const [downloadOpen, setDownloadOpen] = useState(false); // State for download dialog
    const [formData, setFormData] = useState({
        name: "",
        number: "",
        discount: "",
    });
    const navigate=useNavigate()
    const [filters, setFilters] = useState({
        name: "",
        discount: "",
    });

    const isAuthorized = hasStoredTabAccess('Summer Camp Referrals');

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDownloadOpen = () => {
        setDownloadOpen(true);
    };

    const handleDownloadClose = () => {
        setDownloadOpen(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        if(!formData.name || !formData.number || !formData.discount) {
            toast.error("Please enter all fields");
            return;
        }
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/summerCamp/addRefer`, formData);
            toast.success(`Added Successfully`);
            handleClose();
        } catch (error) {
            console.error("Error adding referrals: ", error);
            toast.error(`Error in adding`);
        }
    };

    const handleDownloadSubmit = async () => {
        if(!filters.name || !filters.discount) {
            toast.error("Please enter name or discount to download");
            return;
        }
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/summerCamp/export`, filters, {
                responseType: "blob",
            });
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${filters?.name || filters.discount}referrals.xlsx`);
            document.body.appendChild(link);
            link.click();
            toast.success(`Downloaded Successfully`);
            handleDownloadClose();
        } catch (error) {
            console.error("Error downloading referrals: ", error);
            toast.error("Error in downloading");
        }
    };

    if (!isAuthorized) {
        return (
            <div className="container-fluid mt-5">
                <h2>You are unauthorized to access this page</h2>
            </div>
        )
    }

    return (
        <div className="container-fluid" style={{ paddingTop: '4.5vw' }}>
            <div className="align-center-all full-height">
            <Card elevation={3}  className="col-md-12 p-3" style={{ boxShadow: 'none' }}>
                <CardContent>
                    <ToastContainer />
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                            className={styles.mainContainer}
                        >
                           <div
                style={{
                  display: "flex",
                  gap: "1vw",
                  alignItems: "center",
                  marginBottom: "2.25rem",
                }}
              >
                <ArrowBackIosNewRounded
                  onClick={() => {
                    navigate("/dashboard");
                  }}
                  style={{ cursor: "pointer" }}
                />
                <h2
                  style={{ marginRight: "1rem", marginBottom: "0px" }}
                  className="page-header"
                >
                  Summer Camp Referrals
                </h2>
              </div>
              <div className={styles.buttonsContainer}>
                                <Button className="filled-button" onClick={handleDownloadOpen} style={{ marginRight: "0.586vw" }}>
                                    Download Referrals
                                </Button>
                                <Button
                                    className="filled-button"
                                    onClick={handleClickOpen}
                                >
                                    Add New Referrals
                                </Button>
                            </div>
                        </div>
                </CardContent>
            </Card>
            </div>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle style={{fontWeight: '600'}}>Add New Referrals</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Name"
                        type="text"
                        fullWidth
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'transparent',
                                    boxShadow: 'none',
                                },
                            },
                        }}
                        InputLabelProps={{
                            sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                            required: false
                        }}
                        InputProps={{
                            style: {
                                boxShadow: '0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A'
                            },
                        }}
                    />
                    <TextField
                        margin="dense"
                        label="Number"
                        type="number"
                        fullWidth
                        name="number"
                        value={formData.number}
                        onChange={handleChange}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'transparent',
                                    boxShadow: 'none',
                                },
                            },
                        }}
                        InputLabelProps={{
                            sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                            required: false
                        }}
                        InputProps={{
                            style: {
                                boxShadow: '0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A'
                            },
                        }}
                    />
                    <TextField
                        margin="dense"
                        label="Discount"
                        type="number"
                        fullWidth
                        name="discount"
                        value={formData.discount}
                        onChange={handleChange}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'transparent',
                                    boxShadow: 'none',
                                },
                            },
                        }}
                        InputLabelProps={{
                            sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                            required: false
                        }}
                        InputProps={{
                            style: {
                                boxShadow: '0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A'
                            },
                        }}
                    />
                </DialogContent>
                <DialogActions style={{padding: '0 1.757vw 1.757vw 1.757vw', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <Button onClick={handleClose} className="outlined-button" style={{fontSize: '0.875rem', flex: '1'}}>
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} className="filled-button" style={{fontSize: '0.875rem', flex: '1'}}>
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Download Dialog */}
            <Dialog open={downloadOpen} onClose={handleDownloadClose}>
                <DialogTitle style={{fontWeight: '600'}}>Download Referrals</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        className="mb-3"
                        label="Name"
                        type="text"
                        fullWidth
                        name="name"
                        value={filters.name}
                        onChange={handleFilterChange}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'transparent',
                                    boxShadow: 'none',
                                },
                            },
                        }}
                        InputLabelProps={{
                            sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                            required: false
                        }}
                        InputProps={{
                            style: {
                                boxShadow: '0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A'
                            },
                        }}
                    />
                    <TextField
                        margin="dense"
                        label="Discount"
                        type="number"
                        fullWidth
                        name="discount"
                        value={filters.discount}
                        onChange={handleFilterChange}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'transparent',
                                    boxShadow: 'none',
                                },
                            },
                        }}
                        InputLabelProps={{
                            sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                            required: false
                        }}
                        InputProps={{
                            style: {
                                boxShadow: '0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A'
                            },
                        }}
                    />
                </DialogContent>
                <DialogActions style={{padding: '0 1.757vw 1.757vw 1.757vw', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Button onClick={handleDownloadClose} className="outlined-button" style={{fontSize: '0.875rem', flex: '1'}}>
                        Cancel
                    </Button>
                    <Button onClick={handleDownloadSubmit} className="filled-button" style={{fontSize: '0.875rem', flex: '1'}}>
                        Download
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
};

export default SummerCamp;